module.exports = __webpack_public_path__ + "static/media/no_profile_dark.c3b51c9d.png";